import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementPayable_Agreement on AgreementType {
            isActive
            chargingLedger {
                number
            }
        }
    `),
}

/**
 * An agreement can receive a payment when it is active and carries a charging ledger.
 * Posting to an inactive ledger would leave the debt unpaid on the active one.
 */
export function isAgreementPayable(agreement: FragmentOf<typeof graphQLFragments.agreement>) {
    const { isActive, chargingLedger } = readFragment(graphQLFragments.agreement, agreement)

    return Boolean(isActive && chargingLedger?.number)
}

isAgreementPayable.fragments = graphQLFragments
